import { LineListTemplate } from '../../entity/model/line-list-template';
import LineListTemplateStore from '../store/line-list-template-store';
import { toast } from 'react-toastify';

export default class LineListTemplateService {
  constructor(private lineListTemplateStore: LineListTemplateStore) {}

  createLineListTemplate = async (organizationId: string, lineListTemplate: LineListTemplate): Promise<void> => {
    const result = await this.lineListTemplateStore.createLineListTemplate(organizationId, { body: lineListTemplate });
    if (typeof result === 'string')
      toast.error(result);
    else
      toast.success('Line list template created successfully!');
  }

  getLineListTemplates = async (organizationId: string): Promise<LineListTemplate[]> => {
    const result = await this.lineListTemplateStore.getLineListTemplates(organizationId);
    if (typeof result === 'string') {
      toast.error(result);
      return [];
    }
    return result;
  }

  filterTemplates = (searchQuery: string): LineListTemplate[] => {
    return this.lineListTemplateStore.filterTemplates(searchQuery);
  }
} 